import React, { useState, useEffect } from "react";
import { Button, Modal, Form } from "react-bootstrap";
// import logo from "../../images/jm-logo.webp";
// import logo from "../../images/jmf_new_logo_2025.svg"
// import logo from "../../images/jm_financial_newlogo_2025_latest 1.svg"
import logo from "../../images/JMF_Mutual Fund_ Main-fill-new.svg"
import "./HomePopup.css";

const Homepopup = () => {
  // const [isPopupOpen, setIsPopupOpen] = useState('false');
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("option2");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [shouldShowExitButton, setShouldShowExitButton] = useState(false);
  const [shouldShowSubmitButton, setShouldShowSubmitButton] = useState(true);

  const closePopup = () => {
    window.parent.close();
    setIsPopupOpen(false);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsSubmitDisabled(false);
    if (event.target.value === "option1") {
      setShouldShowExitButton(true);
      setShouldShowSubmitButton(false);
    } else {
      setShouldShowExitButton(false);
      setShouldShowSubmitButton(true);
    }
  };
  const handleSubmit = () => {
    localStorage.setItem("popupClosedTimestamp", Date.now());
    // closePopup();
    setIsPopupOpen(false);
  };


  useEffect(() => {
    const popupClosedTimestamp = localStorage.getItem("popupClosedTimestamp");
    const formSubmitted = localStorage.getItem("formSubmitted");
    const isNewDay = popupClosedTimestamp
      ? new Date().getDate() !==
        new Date(parseInt(popupClosedTimestamp, 10)).getDate()
      : true;
    if (formSubmitted || !popupClosedTimestamp || isNewDay) {
      setIsPopupOpen(true);
    } else {
      setIsPopupOpen(false);
    }
  }, []);

  const closePopupTab = () => {};

  return (
    <div className="popupmod">
      <Modal
        show={isPopupOpen}
        onHide={closePopup}
        backdrop="static"
        keyboard={true}
        className="modal modal-home"
      >
        <Modal.Header>
          <div className="logo-img">
            <a href="/">
              <img src={logo} alt="JM_MutualFund Logo" className="img-fluid" />
            </a>
          </div>
        </Modal.Header>
        <Modal.Body id="modal_info">
          <p className="modal_info">
            {" "}
            The information contained in this website is not intended for any
            person who is a resident of the United States of America or a
            resident of any jurisdiction, the laws of which impose a prohibition
            on soliciting the securities business in that jurisdiction without
            going through the registration requirements and/or prohibit the use
            of any information contained on this website.
          </p>

          <Form>
            <fieldset>
            <Form.Group>
              <legend className="form-label">Confirm your residency status</legend>
              {/* <Form.Label>Choose an option:</Form.Label> */}
              <Form.Check
                type="radio"
                id="resident-no"
                name="residency"
                label={
                  <>
                    I hereby confirm that{" "}
                    <strong>
                      I AM NOT a resident of the United States of America or
                      Canada
                    </strong>{" "}
                    or a resident of any jurisdiction, the laws of which impose
                    a prohibition on soliciting the securities business in that
                    jurisdiction without going through the registration
                    requirements and/or prohibit the use of any information
                    contained on this website.
                  </>
                }
                value="option2"
                checked={selectedOption === "option2"}
                onChange={handleOptionChange}
              />
              <Form.Check
                type="radio"
                id="resident-yes"
                name="residency"
                label={
                  <>
                    I hereby confirm that{" "}
                    <strong>
                      {" "}
                      I AM a resident of the United States of America or Canada{" "}
                    </strong>{" "}
                    or a resident of any jurisdiction, the laws of which impose
                    a prohibition on soliciting the securities business in that
                    jurisdiction without going through the registration
                    requirements and/or prohibit the use of any information
                    contained on this website.
                  </>
                }
                value="option1"
                checked={selectedOption === "option1"}
                onChange={handleOptionChange}
              />
            </Form.Group>
            </fieldset>
          </Form>
          {/* <br></br> */}
          {/* <p>"This is a beta version (under development) link of our website and is available only for the purpose of selected users. Please <a href='https://www.jmfinancialmf.com/'>click here</a>  in case you want to access our existing website." </p> */}
        </Modal.Body>
        <Modal.Footer>
          {shouldShowExitButton && (
            <Button variant="secondary" onClick={closePopup}>
              Exit
            </Button>
          )}
          {shouldShowSubmitButton && (
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitDisabled}
              className="submit-button"
              style={{backgroundColor : "#013c66"}}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Homepopup;
